import { RefObject } from "react";

export const getScrollParent = (node: HTMLElement | null): HTMLElement | null => {
    if (node === null) {
        return null;
    }

    if (node.scrollHeight > node.clientHeight || node.className.includes("scrollable")) {
        return node;
    } else {
        return node.parentNode as HTMLElement | null;
    }
};

export const getScrollElementWithRef = (
    pageView: boolean,
    scrollRef: RefObject<HTMLElement>,
): HTMLElement | null | undefined => {
    return pageView ? scrollRef.current?.parentNode?.parentNode?.parentNode?.parentElement : scrollRef.current;
};
